<p-dialog modal="true" styleClass="atlas-dialog-s" position="middle" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{ 'communications.mass-comm-message-edit.analytics.action-dropdown.open-recipients-profile-selector' | translate | titlecase }}
    </h4>
  </ng-template>
  <div>
    <div class="mct-flex mct-col mct-gap-10">
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-5">
        <p-radioButton
          [(ngModel)]="searchDto.SearchOption"
          name="messageProfileIdOption"
          [value]="messageProfileIdSearchOptionEnum.AllProfilesSentEmail"
          inputId="allProfilesSentEmail"
        >
        </p-radioButton>
        <label for="allProfilesSentEmail">
          {{ 'communications.mass-comm-message-edit.analytics.profile-selector-modal.all-profiles-sent-email' | translate | ucfirst }}
        </label>
      </div>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-5">
        <p-radioButton
          [(ngModel)]="searchDto.SearchOption"
          name="messageProfileIdOption"
          [value]="messageProfileIdSearchOptionEnum.AllProfilesOpenedEmail"
          inputId="allProfilesOpenedEmail"
        >
        </p-radioButton>
        <label for="allProfilesOpenedEmail">
          {{ 'communications.mass-comm-message-edit.analytics.profile-selector-modal.all-profiles-opened-email' | translate | ucfirst }}
        </label>
      </div>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-5">
        <p-radioButton
          [(ngModel)]="searchDto.SearchOption"
          name="messageProfileIdOption"
          [value]="messageProfileIdSearchOptionEnum.AllProfilesNotOpenEmail"
          inputId="allProfilesNotOpenEmail"
        >
        </p-radioButton>
        <label for="allProfilesNotOpenEmail">
          {{
            'communications.mass-comm-message-edit.analytics.profile-selector-modal.all-profiles-did-not-open-email' | translate | ucfirst
          }}
        </label>
      </div>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-5">
        <p-radioButton
          [(ngModel)]="searchDto.SearchOption"
          name="messageProfileIdOption"
          [value]="messageProfileIdSearchOptionEnum.AllProfilesClickOnLink"
          inputId="allProfilesClickOnLink"
        >
        </p-radioButton>
        <label for="allProfilesClickOnLink">
          {{ 'communications.mass-comm-message-edit.analytics.profile-selector-modal.all-profiles-click-link' | translate | ucfirst }}
        </label>
      </div>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-5">
        <p-radioButton
          [(ngModel)]="searchDto.SearchOption"
          name="messageProfileIdOption"
          [value]="messageProfileIdSearchOptionEnum.AllProfilesNotClickOnLink"
          inputId="allProfilesNotClickOnLink"
        >
        </p-radioButton>
        <label for="allProfilesNotClickOnLink">
          {{
            'communications.mass-comm-message-edit.analytics.profile-selector-modal.all-profiles-did-not-click-link' | translate | ucfirst
          }}
        </label>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isLoading" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      [disabled]="isLoading || searchDto.SearchOption == null"
      (click)="openInProfileSelector()"
    >
      <wl-busy [show]="isLoading"></wl-busy>
      <span [hidden]="isLoading">{{
        'communications.mass-comm-message-edit.analytics.profile-selector-modal.open-in-selector' | translate | uppercase
      }}</span>
    </button>
  </ng-template>
</p-dialog>
